export const QC_PLATFORM_IDS = ['zepto', 'blinkit', 'instamart'];

export function isQcPlatformId(platformId) {
  return QC_PLATFORM_IDS.includes(platformId);
}

export function isQuickCommerceHubFilter(platformFilter) {
  return platformFilter === 'quick_commerce' || isQcPlatformId(platformFilter);
}
